import { render } from "./QueueDetailTable.vue?vue&type=template&id=d07502d6"
import script from "./QueueDetailTable.vue?vue&type=script&lang=js"
export * from "./QueueDetailTable.vue?vue&type=script&lang=js"

import "./QueueDetailTable.vue?vue&type=style&index=0&id=d07502d6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__